<template>
    <router-view />
</template>

<style>
@import '@/assets/style.css';
</style>

<script>
export default {
    name: 'App',
};
</script>